/**
 * Session Expired Modal
 *
 * Displays when the user's session has expired and they need to sign in again.
 * Provides a clear message and action to redirect to sign-in.
 *
 * Requirements: 2.3, 2.6
 */

import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';

export function SessionExpiredModal() {
  const navigate = useNavigate();
  const { sessionExpired, clearSessionExpired } = useAuth();

  if (!sessionExpired) {
    return null;
  }

  const handleSignIn = () => {
    clearSessionExpired();
    navigate('/sign-in');
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
    >
      <div className="bg-bbx-dark-800 rounded-card p-6 max-w-sm mx-4 shadow-xl">
        <div className="text-center space-y-4">
          <div>
            <span className="text-4xl">⏰</span>
          </div>
          <h2
            id="session-expired-title"
            className="text-xl font-bold text-bbx-dark-100"
          >
            Session Expired
          </h2>
          <p className="text-bbx-dark-400">
            Your session has expired. Please sign in again to continue.
          </p>
          <button
            onClick={handleSignIn}
            className="w-full px-4 py-3 bg-bbx-primary-600 hover:bg-bbx-primary-500 text-white font-medium rounded-lg transition-colors min-h-tap"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
